import { Box, Typography } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import { SpaceBetweenBox } from "components/GeneralStyled";

function SuccessTradeInitial({ tradeInsertInitial }) {
  return (
    <>
      <Box>
        {tradeInsertInitial?.succeeded ? (
          <>
            <Typography
              display="flex"
              justifyContent="center"
              paddingBottom={1}
              variant="h5"
              component="small"
              fontWeight={300}
              color={
                tradeInsertInitial?.data?.side === "Buy"
                  ? "success.main"
                  : "error.main"
              }
            >
              {tradeInsertInitial?.data?.side} {tradeInsertInitial?.data?.type}
            </Typography>

            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6" fontWeight={300}>
                Amount
              </Typography>

              <Typography textAlign="end">
                <Typography component="b" color="text.main" variant="h5">
                  <NumberFormats value={tradeInsertInitial?.data?.filled} />
                </Typography>{" "}
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="small"
                >
                  {" "}
                  {tradeInsertInitial?.data?.coinSourceName}
                </Typography>
              </Typography>
            </SpaceBetweenBox>

            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6" fontWeight={300}>
                Fee
              </Typography>

              <Typography textAlign="end">
                <Typography component="b" variant="h5" color="text.main">
                  <NumberFormats value={tradeInsertInitial?.data?.fee} />{" "}
                </Typography>{" "}
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="small"
                >
                  {" "}
                  {tradeInsertInitial?.data?.coinFeeName}
                </Typography>
              </Typography>
            </SpaceBetweenBox>

            <SpaceBetweenBox>
              <Typography color="text.secondary" variant="h6" fontWeight={300}>
                Total
              </Typography>

              <Typography textAlign="end">
                <Typography component="b" variant="h5" color="text.main">
                  <NumberFormats value={tradeInsertInitial?.data?.total} />{" "}
                </Typography>

                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="small"
                >
                  {" "}
                  {tradeInsertInitial?.data?.coinDestinationName}
                </Typography>
              </Typography>
            </SpaceBetweenBox>
          </>
        ) : (
          <Typography>ERROR</Typography>
        )}
      </Box>
    </>
  );
}

export default SuccessTradeInitial;
